module.exports = __webpack_public_path__ + "img/67c1121.png";